export const baseURL = '/users';

export const settings = {
  resultsPerPage: 25,
  defaultOrderBy: 'lastName',
  defaultOrder: 1 // 1=asc 0=desc
};
